import { render, staticRenderFns } from "./questionManage.vue?vue&type=template&id=31d3a20d"
import script from "./questionManage.vue?vue&type=script&lang=js"
export * from "./questionManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports